import { Component } from '@angular/core';

import { ComparisonSlider } from '@shared/components';

@Component({
  selector: 'app-evrn-image-scene',
  templateUrl: './evrn-image-scene.html',
  styleUrl: './evrn-image-scene.scss',
  imports: [ComparisonSlider],
})
export class EvrnImageScene {}
